import React from "react";
import classNames from "classnames";
import styles from "./spinIcon.css";

interface Props {
  hidden?: boolean;
}
export const SpinIcon = ({ hidden }: Props) => {
  return (
    <i
      className={classNames(styles.icon, styles["icon-spin"], "icon-spin", {
        [styles["icon-hidden"]]: hidden
      })}
    />
  );
};
